import { NeighborhoodNodeOverlayBehavior } from '@ispm/shared/bpmn-io/behavior/neighborhood-node-overlay-behavior';
import EventBus from 'diagram-js/lib/core/EventBus';
import {TreeNavigator} from '@ispm/shared/bpmn-io/services/tree-navigator';
import {Shape} from 'diagram-js/lib/model';
import {InjectionNames} from '@ispm/shared/bpmn-io/bpmn-js';
import {NeighborhoodHeadNameUpdater} from '@ispm-client/modules/bpmn-modeler/bpmn/utils/neighborhood-head-name-updater';

export class ModelerNeighborNodeOverlayBehavior extends NeighborhoodNodeOverlayBehavior {
  constructor(eventBus: EventBus, overlays, treeNavigator: TreeNavigator, private neighborhoodHeadNameUpdater: NeighborhoodHeadNameUpdater) {
    super(eventBus, overlays, treeNavigator);
  }

  navigateToSubTree(neighborhoodEntryNode: Shape) {
    super.navigateToSubTree(neighborhoodEntryNode);
    if (neighborhoodEntryNode.outgoing && neighborhoodEntryNode.outgoing.length > 0 && neighborhoodEntryNode.outgoing[0])
      this.neighborhoodHeadNameUpdater.updateName(neighborhoodEntryNode.outgoing[0].target);

  }

}

ModelerNeighborNodeOverlayBehavior.$inject = [...NeighborhoodNodeOverlayBehavior.$inject, InjectionNames.neighborhoodHeadNameUpdater];
